import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Login from './views/Login.vue'
import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if(to.name == 'Dashboard') {
        return savedPosition;
    }
    return { x: 0, y: 0 };
  },  
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: "/login",
      name: 'login',
      component: Login
    },
    {
      path: "/galleries/:id",
      name: "gallery",
      component: require( './views/Gallery.vue').default
    },
    {
      path: '/profile',
      name: 'Profile',
      component: require(/* webpackChunkName: "about" */ './views/Profile.vue').default
    },
    {
      path: '/search',
      name: 'Search',
      component: require(/* webpackChunkName: "about" */ './views/Search.vue').default
    },
    {
      path: '/upload',
      name: 'Upload',
      component: require(/* webpackChunkName: "about" */ './views/Upload.vue').default
    },
    {
      path: '/administration',
      name: 'Administration',
      component: require(/* webpackChunkName: "about" */ './views/Administration.vue').default
    },
    {
      path: '/friends',
      name: 'Friends',
      component: require( './views/Friends.vue').default
    },
    {
      path: '/friends/:id',
      name: 'Friends',
      component: require( './views/FriendGalleries.vue').default
    },
    {
      path: '/public/galleries/:id',
      name: 'publicGallery',
      component: require( './views/PublicGallery.vue').default
    }
  ]
})

let publicRoutes = {
  'publicGallery': true,
  'login': true
}

export {publicRoutes};

router.beforeEach((to, from, next) => {
  if(store.state.logged_in || publicRoutes[to.name]) {
    next();
  } else {
    next('/login');
  }
});

router.afterEach((to, from) => {
  store.dispatch("routeChanged", to);
})

export default router;
